import { Component, OnInit } from '@angular/core';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-boolean-config',
  templateUrl: './d-con-boolean-config.component.html',
  styles: []
})
export class DConBooleanConfigComponent extends DynamicComponentBase implements OnInit {
  static KEY = 'd-con-boolean-config';
  dataType = DataPointDataType;
  constructor() {
    super();
  }
  ngOnInit() {
    /** 数据类型设置 */
    this.config.dataType = this.dataType.Boolean;
  }
  configChange(config: IDynamicComponentConfig) {
    this.change(config.value);
  }

  change(val) {
    if (typeof val !== 'boolean') {
      if (val === 'true') {
        this.config.value = true;
      } else if (val === 'false') {
        this.config.value = false;
      } else {
        this.config.value = undefined;
      }
    } else {
      this.config.value = val;
    }
  }
}
